import Image from 'global/Image';
import { Common } from '@stockbit/ui';
import { useState } from 'react';
import { ImageWrapper, ImgModal } from '../styled';

const { Modal } = Common;

interface ImageDetailProps {
  src: string;
}

function ImageDetail({ src }: ImageDetailProps) {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <ImageWrapper>
        <Image src={src} alt="stream pict" className="image-convo-default" onClick={() => setVisible(true)} />
        <Image src={src} alt="stream pict" className="image-convo-shadow" onClick={() => setVisible(true)} />
      </ImageWrapper>
      <Modal
        visible={visible}
        centered
        maskClosable
        footer={null}
        width="auto"
        style={{ padding: 0 }}
        onCancel={() => setVisible(false)}
        transitionName=""
        maskTransitionName=""
        closeIcon={<span />}
      >
        <ImgModal alt="" src={src} />
      </Modal>
    </>
  );
}

export default ImageDetail;
